<template>
  <v-dialog value="true"
            persistent
            max-width="800px"
            :fullscreen="isFulscreen"
            transition="dialog-bottom-transition">
    <Terms v-if="state=='terms'"
           ask-user
           @click-agree-button="state='login'"
           @click-disagree-button="state='hello'"/>
    <LoginForm v-if="state=='login'"/>
  </v-dialog>
</template>

<script>
import LoginForm from '@/components/LoginForm'
import Terms from '@/components/Terms'

export default {
  name: 'TopWindow',
  components: {LoginForm, Terms},
  data: function() {
    return {
      state: 'terms',
    }
  },
  computed: {
    isFulscreen: function () {
      return this.state == 'hello';
    }
  }
}
</script>

<style>
/* .v-dialog {
  border-radius: 0 !important;
} */
</style>